<template>
    <nav
        class="fixed h-side-bar rounded-5 bg-purple-light py-6 m-4 z-110 transition-width duration-150 ease-in-out select-none"
        :class="mini ? 'w-19' : 'w-64'"
    >
        <div class="flex flex-col h-full items-center overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-thumb-blue dark:scrollbar-thumb-purple-50">
            <div
                class="cursor-pointer flex w-full "
                :class="mini ? 'justify-center' : 'items-center'"
                @click="openCloseMenu"
            >
                <ArrowLeftIcon v-if="!mini" class="ml-6.5 mr-4" />

                <IconLogo />

                <div v-if="!mini" class="pl-2.5 text-xs text-white font-bold">Moneypage</div>
            </div>

            <div class="pt-4.5 w-full">
                <div class="opacity-10 h-px bg-white"></div>
            </div>

            <div
                class="w-full flex group"
                :class="[
                    mini ? 'justify-center mt-5' : 'px-2.5 mt-2.5',
                    mini && !index ? 'mt-3.75' : ''
                ]"
                v-for="(item, index) in items"
                :key="index"
            >
                <tippy
                    v-if="mini"
                    placement="right-start"
                    hide-on-click
                    interactive
                >
                    <router-link :to="{ name: item.title.split(' ')[0] }">
                        <component
                            class="focus:outline-none group-hover:fill-blue group-hover:text-white"
                            :class="compareNames(item.title) ? 'text-blue' : 'text-white'"
                            :is="item.icon"
                        />
                    </router-link>

                    <template #content="{ hide }" v-if="item.children">
                            <div
                                :class="[
                                currentRouteChildName === child.value ? 'text-purple' : 'text-white',
                                { 'pt-1.25': index },
                            ]"
                                v-for="(child, index) in item.children"
                                :key="child.title + index"
                            >

                                <router-link :to="{ name: child.value.split(' ')[0] }">
                                    <span class="whitespace-nowrap hover:text-purple transition-colors duration-150 ease-in-out">
                                        {{ child.title }}
                                    </span>
                                </router-link>
                            </div>
                    </template>
                </tippy>

                <div
                    v-else
                    class="group w-full rounded-xl hover:bg-purple-400"
                    :class="{ 'bg-purple-400': item.open }"
                >
                    <router-link
                        v-if="!item?.children"
                        :to="{ name: item.title.split(' ')[0] }"
                    >
                        <div
                            class="flex items-center justify-between w-full cursor-pointer py-1.25 px-1.5"
                            :class="compareNames(item.title) ? 'text-blue' : 'text-white'"
                        >
                            <div class="flex items-center">
                                <component
                                    class="group-hover:fill-purple-400 fill-purple-light"
                                    :class="compareNames(item.title) ? 'text-blue' : 'text-white'"
                                    :is="item.icon"
                                />

                                <div
                                    class="pl-1.5 text-sm whitespace-nowrap"
                                    :class="compareNames(item.title) ? 'text-blue' : 'text-white'"
                                >{{ item.title }}</div>
                            </div>

                            <ArrowDownIcon
                                v-if="item.children"
                                class="transform duration-300"
                                :class="{ 'rotate-180': item.open }"
                            />
                        </div>
                    </router-link>

                    <div
                        v-else
                        class="flex items-center justify-between w-full cursor-pointer py-1.25 px-1.5"
                        :class="compareNames(item.title) ? 'text-blue' : 'text-white'"
                        @click="menuAction(item)"
                    >
                        <div class="flex items-center">
                            <component
                                class="group-hover:fill-purple-400"
                                :class="[
                                    compareNames(item.title) ? 'text-blue' : 'text-white',
                                    item.open ? 'fill-purple-400' : 'fill-purple-light'
                                ]"
                                :is="item.icon"
                            />

                            <div
                                class="pl-1.5 text-sm whitespace-nowrap"
                                :class="compareNames(item.title) ? 'text-blue' : 'text-white'"
                            >{{ item.title }}</div>
                        </div>

                        <ArrowDownIcon
                            v-if="item.children"
                            class="transform duration-300"
                            :class="{ 'rotate-180': item.open }"
                        />
                    </div>

                    <div
                        v-if="item.open"
                        class="pl-14 pb-1.5 list-complete-item w-full"
                    >
                        <div
                            class="pb-2.5"
                            :class="currentRouteChildName === child.value ? 'text-blue' : 'text-white'"
                            v-for="(child, index) in item.children"
                            :key="index + child.title"
                        >
                            <router-link :to="{ name: child.value.split(' ')[0] }">
                                    <span class="text-sm whitespace-nowrap hover:text-blue transition-colors duration-150 ease-in-out">
                                        {{ child.title }}
                                    </span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>

import ArrowLeftIcon from '@/components/icons/navigations/ArrowLeftIcon'
import IconLogo from '@/components/icons/navigations/IconLogo'
import DashboardIcon from '@/components/icons/navigations/DashboardIcon'
import TemplatesIcon from '@/components/icons/navigations/TemplatesIcon'
import CampaignsIcon from '@/components/icons/navigations/CampaignsIcon'
import QueuesIcon from '@/components/icons/navigations/QueuesIcon'
import CloakingIcon from '@/components/icons/navigations/CloakingIcon'
import DomainsIcon from '@/components/icons/navigations/DomainsIcon'
import CloudflareIcon from '@/components/icons/navigations/CloudflareIcon'
import ServersIcon from '@/components/icons/navigations/ServersIcon'
import AnalyticsIcon from '@/components/icons/navigations/AnalyticsIcon'
import UserIcon from '@/components/icons/navigations/UserIcon'
import ArrowDownIcon from '@/components/icons/navigations/ArrowDownIcon'

import { mapState, mapGetters } from 'vuex'
import { Types as authTypes } from '@/store/modules/authTypes'

export default {
    name: 'SideBar',
    components: { ArrowLeftIcon, IconLogo, DashboardIcon, TemplatesIcon, CampaignsIcon, QueuesIcon, CloakingIcon, DomainsIcon, CloudflareIcon, ServersIcon, AnalyticsIcon, UserIcon, ArrowDownIcon },
    props: {
        mini: {
            type: Boolean,
            default: true
        },
    },
    data: () => ({
        items: [],
    }),
    computed: {
        ...mapState({
            permissions: state => state.auth.permissions,
        }),
        ...mapGetters({
            isAdmin: authTypes.getters.IS_ADMIN,
        }),
        currentRouteName() {
            return this.$route.matched.length > 1 ? this.$route.matched[0].name : this.$route.name
        },
        currentRouteChildName() {
            return this.$route.matched.length > 1 && this.$route.matched[0].children.length > 1
                ? this.$route.matched[1].name
                : ''
        },
    },
    methods: {
        goTo(name) {
            this.$router.push({ name: name.split(' ')[0] })
        },
        compareNames(itemName) {
            return this.currentRouteName === itemName.split(' ')[0]
        },
        menuAction(item) {
            if (item.children) {
                this.openCloseSubMenu(item)
            } else {
                this.goTo(item.title)
            }
        },
        openCloseMenu() {
            this.$emit('update:mini', !this.mini)
        },
        openCloseSubMenu(item) {
            this.items.forEach(m => {
                if (m.hasOwnProperty('open')) {
                    m.open = m.title === item.title ? !m.open : false
                }
            })
        },
        updateSideBarItems() {
            this.items = [{
                title: 'Dashboard',
                icon: 'dashboard-icon',
            }]

            if (this.permissions['see_templates']) {
                this.items.push({
                    title: 'Templates',
                    icon: 'templates-icon',
                })
            }

            if (this.permissions['see_campaigns']) {
                if (this.permissions['create_campaign']) {
                    this.items.push({
                        title: 'Campaigns',
                        icon: 'campaigns-icon',
                        open: false,
                        children: [
                            { title: 'Manage Campaigns', value: 'ManageCampaigns' },
                            { title: 'Create Campaign', value: 'CreateCampaign' },
                            { title: 'Error log Campaigns', value: 'ErrorCampaign' },
                        ],
                    })
                } else {
                    this.items.push({
                        title: 'Campaigns',
                        icon: 'campaigns-icon',
                    })
                }
            }

            if (this.permissions['see_queues']) {
                if (this.permissions['create_queue'] || this.permissions['see_queue_method_accounts']) {
                    const queueItem = {
                        title: 'Queues',
                        icon: 'queues-icon',
                        open: false,
                        children: [{ title: 'Manage Queues', value: 'ManageQueues' }],
                    }

                    if (this.permissions['create_queue']) {
                        queueItem.children.push({ title: 'Create Queue', value: 'CreateQueue' })
                    }

                    if (this.permissions['see_queue_method_accounts']) {
                        queueItem.children.push({ title: 'Manage Accounts', value: 'ManageIntegrationMethodAccounts' })
                    }

                    this.items.push(queueItem)
                } else {
                    this.items.push({
                        title: 'Queues',
                        icon: 'queues-icon',
                    })
                }
            }

            if (this.permissions['see_cdn_links']) {
                if (this.permissions['create_cdn_links'] || this.permissions['see_cdn_provider_accounts']) {
                    const cdnItem = {
                        title: 'CloudFront',
                        icon: 'cloaking-icon',
                        open: false,
                        children: [{ title: 'Manage Links', value: 'ManageCDN' }],
                    }

                    if (this.permissions['create_cdn_links']) {
                        cdnItem.children.push({ title: 'Create Links', value: 'CreateCDN' })
                    }

                    if (this.permissions['see_cdn_provider_accounts']) {
                        cdnItem.children.push({ title: 'Manage Accounts', value: 'ManageCDNAccounts' })
                    }

                    this.items.push(cdnItem)
                } else {
                    this.items.push({
                        title: 'CloudFront',
                        icon: 'cloaking-icon',
                    })
                }
            }

            if (this.permissions['see_domains']) {
                if (this.permissions['buy_domains'] || this.permissions['see_domain_provider_accounts']) {
                    const domainItem = {
                        title: 'Domains',
                        icon: 'domains-icon',
                        open: false,
                        children: [{ title: 'Manage Domains', value: 'ManageDomains' }],
                    }

                    if (this.permissions['buy_domains']) {
                        domainItem.children.push({ title: 'Buy Domains', value: 'BuyDomains' })
                    }

                    if (this.permissions['see_domain_provider_accounts']) {
                        domainItem.children.push({ title: 'Manage Accounts', value: 'ManageDomainAccounts' })
                    }

                    this.items.push(domainItem)
                } else {
                    this.items.push({
                        title: 'Domains',
                        icon: 'domains-icon',
                    })
                }
            }

            if (this.permissions['see_cloudflare_zones']) {
                if (this.permissions['add_cloudflare_zones'] || this.permissions['see_cloudflare_accounts']) {
                    const serverItem = {
                        title: 'Cloudflare',
                        icon: 'cloudflare-icon',
                        open: false,
                        children: [{ title: 'Manage Domains', value: 'ManageCloudflareDomains' }],
                    }

                    if (this.permissions['add_cloudflare_zones']) {
                        serverItem.children.push({ title: 'Add Domains', value: 'AddCloudflareZones' })
                    }

                    if (this.permissions['see_cloudflare_accounts']) {
                        serverItem.children.push({ title: 'Manage Accounts', value: 'ManageCloudflareAccounts' })
                    }

                    this.items.push(serverItem)
                } else {
                    this.items.push({
                        title: 'Cloudflare',
                        icon: 'cloudflare-icon',
                    })
                }
            }

            if (this.permissions['see_cloud_provider_servers']) {
                if (this.permissions['create_cloud_provider_servers'] || this.permissions['see_cloud_provider_accounts']) {
                    const serverItem = {
                        title: 'Servers',
                        icon: 'servers-icon',
                        open: false,
                        children: [{ title: 'Manage Cloud Servers', value: 'ManageCloudServers' }],
                    }

                    if (this.permissions['create_cloud_provider_servers']) {
                        serverItem.children.push({ title: 'Create Cloud Server', value: 'CreateCloudServers' })
                    }

                    serverItem.children.push({ title: 'Manage Domains', value: 'DomainsCloudServers'})

                    if (this.permissions['see_cloud_provider_accounts']) {
                        serverItem.children.push({ title: 'Manage Accounts', value: 'ManageCloudServersAccounts' })
                    }

                    this.items.push(serverItem)
                } else {
                    this.items.push({
                        title: 'Servers',
                        icon: 'servers-icon',
                    })
                }
            }

            if (this.isAdmin) {
                this.items.push({
                    title: 'Users',
                    icon: 'user-icon',
                    open: false,
                    children: [
                        { title: 'Manage Users', value: 'ManageUsers' },
                        { title: 'Create Role', value: 'CreateRole' },
                        { title: 'Manage Users Roles', value: 'ManageUsersRoles' },
                    ],
                })
            }
        },
    },
    watch: {
        permissions: {
            immediate: true,
            handler() {
                this.updateSideBarItems()
            }
        },
        isAdmin: {
            immediate: true,
            handler() {
                this.updateSideBarItems()
            }
        },
    },
}
</script>
